import React from "react";
import { Box, Typography, Switch, styled, TextField } from "@mui/material";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 40, 
  height: 20, 
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 3, 
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 14,
    height: 14,
    color: "#fff",
  },
  "& .MuiSwitch-track": {
    borderRadius: 10,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
  },
}));

const RiskToggle = ({ handleToggle, isResidualRisk, selectedResidualDate, handleResidualDateChange, selectedInherantDate,
  handleInherantDateChange }) => {


  return (
    <Box display="flex" alignItems="center" justifyContent="center" sx={{ marginTop: 1 }}>
      {/* Inherent Risk Section */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{ cursor: "pointer", marginRight: 2 }}
      >
        <Typography
          variant="body2" 
          color={!isResidualRisk ? "blue" : "gray"}
          fontWeight={!isResidualRisk ? "bold" : "normal"}
        >
          Inherent Risk
        </Typography>
      </Box>

      {/* Switch */}
      <CustomSwitch
        checked={isResidualRisk}
        onChange={handleToggle}
        color="primary"
      />

      {/* Residual Risk Section */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{ cursor: "pointer", marginLeft: 2 }}
      >
        <Typography
          variant="body2"
          color={isResidualRisk ? "blue" : "gray"}
          fontWeight={isResidualRisk ? "bold" : "normal"}
        >
          Residual Risk
        </Typography>
        {/* <TextField
          type="date"
          size="small"
          value={selectedResidualDate}
          onChange={handleResidualDateChange}
          disabled={!isResidualRisk} // Disable based on toggle state
          sx={{
            width: 110, 
            marginTop: 0.5,
          }}
          inputProps={{ style: { fontSize: "12px" } }} 
        /> */}
      </Box>
    </Box>
  );
};

export default RiskToggle;
